import { DATE_HEADERS } from './dates-const';

export const isNumber = (value) => value && !isNaN(value);

export const isMoney = (value, key) => isNumber(value) && (value.toString().includes('.') || (key && key.includes('pris')));

export const isQuantity = (value, key) => isNumber(value) && (key && key.includes('ANTAL') && !key.includes('/'));

export const isDate = (key) => key && DATE_HEADERS.some(header => key.includes(header));

export const getMachineProperty = (machines, machineId, property) => {
  return machines?.find(machine => machine.Id === machineId)?.[property] || '';
};

export const transformToMachineOptions = (machines) => {
  return machines.map(({ Name, Id, CustomerName }) => ({
    label: Name,
    value: Id,
    customerName: CustomerName,
  }));
};

export const generateUniqueCustomerOptions = (machines) => {
  return [...new Set(machines.map(machine => machine.CustomerName))]
    .map(CustomerName => ({
      label: CustomerName,
      value: CustomerName,
    }));
};